import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const ListHomeFeatures = () => {
  const [features, setFeatures] = useState([]);
  const token = sessionStorage.getItem("authToken");

  const fetchFeatures = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getAllHomeFeatures`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFeatures(res.data.features || []);
    } catch (err) {
      console.error("Error fetching home features:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this feature?")) return;
    try {
      await axios.delete(`${COMMON_API}/loan/deleteHomeFeatures/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
       
      setFeatures(features.filter((f) => f.id !== id));
    } catch (err) {
      console.error("Error deleting feature:", err);
    }
  };

  useEffect(() => {
    fetchFeatures();

  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Home Features</h2>
          <Link
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
            to="/add-home-features"
          >
            + Add Feature
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
        
            <div
              key={feature.id}
              
              className="border rounded-xl shadow-sm bg-gray-50 p-4 flex flex-col justify-between hover:shadow-md transition"
            >
              <div>
                <h3 className="text-lg font-semibold text-gray-700">{feature.title}</h3>
                <p className="text-gray-600 mt-1">{feature.description}</p>
                {feature.image && (
                  <img
                    src={`${COMMON_API}/ImgUploads/${feature.image}`}
                    alt={feature.title}
                    className="w-full h-40 object-cover rounded-lg mt-3"
                  />
                )}
              </div>
              <div className="flex gap-3 mt-4">
                <Link
                  to={`/edit-home-features/${feature.id}`}
                  className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition"
                >
                  Edit
                </Link>
                <button
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                  onClick={() => handleDelete(feature.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          {features.length === 0 && (
            <p className="text-gray-500 col-span-full text-center">No features found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListHomeFeatures;
